<template>
  <v-container>
    <v-tab-item class="pb-12">
      <saneamento-voc-first-wizard-tab
        :campos.sync="firstTab"
        @secondStepAvailable="$emit('secondStepAvailable', $event)"
      />
    </v-tab-item>

    <v-tab-item class="pb-12">
      <saneamento-voc-second-wizard-tab
        :campos.sync="secondTab"
        @thirdStepAvailable="$emit('thirdStepAvailable', $event)"
      />
    </v-tab-item>

    <v-tab-item class="pb-12">
      <saneamento-voc-third-wizard-tab
        :campos.sync="thirdTab"
        @fourthStepAvailable="$emit('fourthStepAvailable', $event)"
        :cadernosServicosExistentes="cadernosServicosExistentes"
        :filtros="filtros"
      />
    </v-tab-item>

    <v-tab-item class="pb-12">
      <saneamento-voc-fourth-wizard-tab
        :campos.sync="fourthTab"
        @btnFinishAvailable="$emit('btnFinishAvailable', $event)"
        :cmuExistentes="cmuExistentes"
        :normasTecnicasExistentes="normasTecnicasExistentes"
        :parametrosEspecificosRacCom="parametrosEspecificosRacCom"
      />
    </v-tab-item>
  </v-container>
</template>

<script>
  import ConfiguracoesService from "@/services/ConfiguracoesService.js";
  import DateFormatterMixins from "@/mixins/dateFormatterMixins.js";

  export default {
    name: "SaneamentoVocWizardTabs",

    components: {
      SaneamentoVocFirstWizardTab: () =>
        import("@/components/saneamentoVoc/wizardTabs/SaneamentoVocFirstWizardTab.vue"),
      SaneamentoVocSecondWizardTab: () =>
        import("@/components/saneamentoVoc/wizardTabs/SaneamentoVocSecondWizardTab.vue"),
      SaneamentoVocThirdWizardTab: () =>
        import("@/components/saneamentoVoc/wizardTabs/SaneamentoVocThirdWizardTab.vue"),
      SaneamentoVocFourthWizardTab: () =>
        import("@/components/saneamentoVoc/wizardTabs/SaneamentoVocFourthWizardTab.vue"),
    },

    mixins: [DateFormatterMixins],

    props: {
      calculo: {
        type: Object,
        required: false,
        default: () => {},
      },
      bensDeInfraestrutura: {
        type: Array,
        required: false,
        default: () => [],
      },
      cadernosServicosExistentes: {
        type: Array,
        required: true,
      },
      cmuExistentes: {
        type: Array,
        required: true,
      },
      normasTecnicasExistentes: {
        type: Array,
        required: true,
      },
      parametrosEspecificosRacCom: {
        type: Array,
        required: true,
      },
    },

    data() {
      return {
        firstTab: {
          titulo: "",
          obras: "",
          tipologias: "",
          obrasNaoPertencem: false,
          tipologiasNaoPertencem: false,
          menuPickerImob: [false, false],
          dataImob: {
            inicioFormatted: "",
            inicio: "",
            fimFormatted: "",
            fim: "",
          },
          tipoBase: "AMBAS",
        },
        secondTab: {
          aplicarFlags: false,
          flagsPanels: [],
          criarListaExcecaoObras: false,
          criarListaExcecaoMateriais: false,
          obrasNaoAplicaveis: "",
          materiaisNaoAplicaveis: "",
          flags: {
            flag_uar_zero: {
              label: "Obra com UAR <= 10%",
              aplicacaoList: [
                { text: "NÃO APLICAR", value: "NAO_APLICAR" },
                { text: "APLICAR NA OBRA", value: "APLICAR_NA_OBRA" },
              ],
              aplicacao: "NAO_APLICAR",
              percentualFalha: 0,
            },
            flag_data: {
              label: "Flag Data",
              aplicacaoList: [
                { text: "NÃO APLICAR", value: "NAO_APLICAR" },
                { text: "APLICAR NOS LANÇAMENTOS", value: "APLICAR_NOS_LANCAMENTOS" },
              ],
              aplicacao: "NAO_APLICAR",
              percentualFalha: 0,
              janelaDataImob: false,
              periodosDataLancamento: {
                diasAntes: 90,
                diasDepois: 90,
                diasAntesRedesAereas: 150,
                diasDepoisRedesAereas: 150,
                diasAntesRedesSubterraneas: 180,
                diasDepoisRedesSubterraneas: 180,
                diasAntesMedidores: 90,
                diasDepoisMedidores: 90,
                diasAntesSubestacoes: 270,
                diasDepoisSubestacoes: 270,
                diasAntesLinhas: 360,
                diasDepoisLinhas: 360,
                aplicarPeriodoRedesAereas: false,
                aplicarPeriodoRedesSubterraneas: false,
                aplicarPeriodoMedidores: false,
                aplicarPeriodoSubestacoes: false,
                aplicarPeriodoLinhas: false,
              },
              desconsiderarItensZeradosOuNegativos: false,
              expurgarItensRacionalizacaoCOM: false,
            },
          },
        },
        thirdTab: {
          aplicarCadernoServicos: false,
          camposPercentuaisPadroes: {
            joa: { label: "JOA", value: 0 },
            materialCOM: { label: "Material - COM", value: 0 },
            materialUAR: { label: "Material - UAR", value: 0 },
            mop: { label: "MOP", value: 0 },
            outros: { label: "Outros", value: 0 },
            servTec: { label: "Serv. Terc.", value: 0 },
          },
          cadernoServico: {
            origem: "sistema",
            origemList: [
              { text: "% Padrões por Natureza de Gasto ANEEL", value: "sistema" },
              { text: "Caderno Existente", value: "existente" },
              { text: "Arquivo CSV", value: "novo" },
            ],
            nome: "",
            id: "",
            arquivo: {
              id: "",
              fileObj: undefined,
              arquivoId: "",
              delimitador: `;`,
              involucro: `"`,
              escape: `"`,
              uploading: false,
              fakeFile: false,
              headerValido: false,
            },
          },
        },
        fourthTab: {
          calculoRacionalizacaoDoCom: false,
          cmu: {
            origem: "existente",
            origemList: [
              { text: "CMU Existente", value: "existente" },
              { text: "Arquivo CSV", value: "novo" },
            ],
            id: "",
            nome: "",
            arquivo: {
              id: "",
              fileObj: undefined,
              arquivoId: "",
              delimitador: `;`,
              involucro: `"`,
              escape: `"`,
              uploading: false,
              headerValido: false,
              fakeFile: false,
            },
            valores: {},
          },
          normasTecnicas: {
            origem: "existente",
            origemList: [
              { text: "Normas Técnicas Existente", value: "existente" },
              { text: "Arquivo CSV", value: "novo" },
            ],
            nome: "",
            id: "",
            arquivo: {
              id: "",
              fileObj: undefined,
              arquivoId: "",
              delimitador: `;`,
              involucro: `"`,
              escape: `"`,
              uploading: false,
              headerValido: false,
              fakeFile: false,
            },
            valores: {},
          },
          parametrosEspecificosRacCom: [],
        },
      };
    },

    computed: {
      user() {
        return this.$store.getters.getUser;
      },
      filtros() {
        return {
          obras: this.firstTab.obras,
          obrasNaoPertencem: this.firstTab.obrasNaoPertencem,
          tipologias: this.firstTab.tipologias,
          tipologiasNaoPertencem: this.firstTab.tipologiasNaoPertencem,
          dataImobilizacaoInicial: this.firstTab.dataImob.inicioFormatted,
          dataImobilizacaoFinal: this.firstTab.dataImob.fimFormatted,
          tipoBase: this.firstTab.tipoBase,
        };
      },
    },

    mounted() {
      if (!this.$route.params.id) {
        this.getParamentosJanelaFlagData();
      }
    },

    methods: {
      getParamentosJanelaFlagData() {
        ConfiguracoesService.getParamentosJanelaFlagData()
          .then((res) => {
            const parametros = res.data;
            this.secondTab.flags.flag_data.periodosDataLancamento.diasAntes = parametros.flagDataNumDiasAntes ?? 90;
            this.secondTab.flags.flag_data.periodosDataLancamento.diasDepois = parametros.flagDataNumDiasDepois ?? 90;
          })
          .catch((err) => {
            console.error(
              "Erro ao recuperar os números de dias limites para a criação das janelas de Flag Data: ",
              err
            );
            this.$toast.error(
              "Erro ao recuperar os números de dias limites para a criação das janelas de Flag Data.",
              "",
              { position: "topRight" }
            );
          });
      },
      exportData() {
        const _flags = this.secondTab.flags;

        let filtrosEdit = {
          obrasNaoPertencemALista: this.firstTab.obrasNaoPertencem ? 1 : 0,
          obras: this.firstTab.obras,
          tipologiasNaoPertencemALista: this.firstTab.tipologiasNaoPertencem ? 1 : 0,
          tipologias: this.firstTab.tipologias,
          dataImobilizacaoInicial: this.firstTab.dataImob.inicioFormatted,
          dataImobilizacaoFinal: this.firstTab.dataImob.fimFormatted,
          tipoBase: this.firstTab.tipoBase,
        };

        return {
          nome: this.firstTab.titulo,

          filtros: filtrosEdit,

          parametros: {
            calculoDeCA: this.secondTab.aplicarFlags || this.thirdTab.aplicarCadernoServicos ? 1 : 0,
            racionalizacaoDoCOM: this.fourthTab.calculoRacionalizacaoDoCom ? 1 : 0,

            aplicarFlags: this.secondTab.aplicarFlags ? 1 : 0,
            aplicarCadernoServicos: this.thirdTab.aplicarCadernoServicos ? 1 : 0,

            // Necessário para definar regras exclusivas para o HEXA_V2
            hexa_v2: 1,

            flagsCriarListaExcecaoObras: this.secondTab.criarListaExcecaoObras ? 1 : 0,
            flagsObrasNaoAplicaveis: this.secondTab.criarListaExcecaoObras ? this.secondTab.obrasNaoAplicaveis : "",

            flagsCriarListaExcecaoMaterias: this.secondTab.criarListaExcecaoMateriais ? 1 : 0,
            flagsMateriaisNaoAplicaveis: this.secondTab.criarListaExcecaoMateriais
              ? this.secondTab.materiaisNaoAplicaveis
              : "",

            // Flag Obra com UAR <= 10%
            FLG_ODI_UAR_ZERO: {
              aplicar: this.secondTab.aplicarFlags ? _flags.flag_uar_zero.aplicacao : "NAO_APLICAR",
              perc_ok: 1,
              perc_falha: _flags.flag_uar_zero.percentualFalha,
            },
            // Flag Flag Data
            FLG_ERR_DT_LMTO: {
              aplicar: this.secondTab.aplicarFlags ? _flags.flag_data.aplicacao : "NAO_APLICAR",
              perc_ok: 1,
              perc_falha: _flags.flag_data.percentualFalha,
              incluirJanelaDataImobilizacao: _flags.flag_data.janelaDataImob ? 1 : 0,
              numDiasAntes: _flags.flag_data.periodosDataLancamento.diasAntes,
              numDiasDepois: _flags.flag_data.periodosDataLancamento.diasDepois,
              desconsiderarItensZeradosOuNegativos: _flags.flag_data.desconsiderarItensZeradosOuNegativos ? 1 : 0,
              expurgarItensRacionalizacaoCOM: _flags.flag_data.expurgarItensRacionalizacaoCOM ? 1 : 0,
              periodosDataLancamentoPorTipologia: {
                diasAntesRedesAereas: _flags.flag_data.periodosDataLancamento.diasAntesRedesAereas,
                diasDepoisRedesAereas: _flags.flag_data.periodosDataLancamento.diasDepoisRedesAereas,
                diasAntesRedesSubterraneas: _flags.flag_data.periodosDataLancamento.diasAntesRedesSubterraneas,
                diasDepoisRedesSubterraneas: _flags.flag_data.periodosDataLancamento.diasDepoisRedesSubterraneas,
                diasAntesMedidores: _flags.flag_data.periodosDataLancamento.diasAntesMedidores,
                diasDepoisMedidores: _flags.flag_data.periodosDataLancamento.diasDepoisMedidores,
                diasAntesSubestacoes: _flags.flag_data.periodosDataLancamento.diasAntesSubestacoes,
                diasDepoisSubestacoes: _flags.flag_data.periodosDataLancamento.diasDepoisSubestacoes,
                diasAntesLinhas: _flags.flag_data.periodosDataLancamento.diasAntesLinhas,
                diasDepoisLinhas: _flags.flag_data.periodosDataLancamento.diasDepoisLinhas,
                aplicarPeriodoRedesAereas: _flags.flag_data.periodosDataLancamento.aplicarPeriodoRedesAereas ? 1 : 0,
                aplicarPeriodoRedesSubterraneas: _flags.flag_data.periodosDataLancamento.aplicarPeriodoRedesSubterraneas
                  ? 1
                  : 0,
                aplicarPeriodoMedidores: _flags.flag_data.periodosDataLancamento.aplicarPeriodoMedidores ? 1 : 0,
                aplicarPeriodoSubestacoes: _flags.flag_data.periodosDataLancamento.aplicarPeriodoSubestacoes ? 1 : 0,
                aplicarPeriodoLinhas: _flags.flag_data.periodosDataLancamento.aplicarPeriodoLinhas ? 1 : 0,
              },
            },

            percentuais_padroes: {
              JOA: this.thirdTab.camposPercentuaisPadroes.joa.value,
              "Material - COM": this.thirdTab.camposPercentuaisPadroes.materialCOM.value,
              "Material - UAR": this.thirdTab.camposPercentuaisPadroes.materialUAR.value,
              MOP: this.thirdTab.camposPercentuaisPadroes.mop.value,
              Outros: this.thirdTab.camposPercentuaisPadroes.outros.value,
              "Serv. Terc.": this.thirdTab.camposPercentuaisPadroes.servTec.value,
            },

            siglas_aneel_valores: this.fourthTab.cmu.valores, // CMU
            normas_quantidades_com: this.fourthTab.normasTecnicas.valores, // Normas Tecnicas
            parametrosEspecificosRacCom: this.fourthTab.parametrosEspecificosRacCom, // Parametros especificos para o calculo
          },

          // CMU:
          valores_unitarios: {
            nome: this.fourthTab.cmu.nome,
            salvar: this.fourthTab.cmu.origem == "novo" ? true : false,
          },
          cmu_id: this.fourthTab.cmu.origem == "novo" ? "" : this.fourthTab.cmu.id,

          // Normas Tecnicas:
          normas_tecnicas: {
            nome: this.fourthTab.normasTecnicas.nome,
            salvar: this.fourthTab.normasTecnicas.origem == "novo" ? true : false,
          },
          normas_tecnicas_id: this.fourthTab.normasTecnicas.origem == "novo" ? "" : this.fourthTab.normasTecnicas.id,

          // Caderno de Serviços:
          cadernos_servicos: {
            nome: this.thirdTab.cadernoServico.nome,
            salvar:
              this.thirdTab.cadernoServico.origem == "novo" && !this.thirdTab.cadernoServico.arquivo.fakeFile
                ? true
                : false,
          },
          origem_caderno_servicos:
            this.thirdTab.aplicarCadernoServicos && this.thirdTab.cadernoServico.origem === "novo"
              ? "CSV"
              : this.thirdTab.aplicarCadernoServicos && this.thirdTab.cadernoServico.origem === "existente"
              ? "CADERNO"
              : "SISTEMA",
          arquivoId: this.thirdTab.cadernoServico.origem == "novo" ? this.thirdTab.cadernoServico.arquivo.id : "",
          caderno_servicos_id: this.thirdTab.cadernoServico.origem == "novo" ? "" : this.thirdTab.cadernoServico.id,
          delimitador: this.thirdTab.cadernoServico.arquivo.delimitador,
          involucro: this.thirdTab.cadernoServico.arquivo.involucro,
          escape: this.thirdTab.cadernoServico.arquivo.escape,

          // Necessário para salvar os Parametros de COM e CA
          usuario_id: this.user.id_hexa,
        };
      },
      fillFields() {
        const item = this.calculo;

        this.firstTab.titulo = item.nome;

        this.secondTab.aplicarFlags = item.parametros.aplicarFlags == 1 ? true : false;
        this.thirdTab.aplicarCadernoServicos = item.parametros.aplicarCadernoServicos == 1 ? true : false;
        this.fourthTab.calculoRacionalizacaoDoCom = item.parametros.racionalizacaoDoCOM == 1 ? true : false;

        this.firstTab.obras = item.filtros.obras;
        this.firstTab.obrasNaoPertencem = item.filtros.obrasNaoPertencemALista == 1 ? true : false;
        this.firstTab.tipologias = item.filtros.tipologias;
        this.firstTab.tipologiasNaoPertencem = item.filtros.tipologiasNaoPertencemALista == 1 ? true : false;

        this.firstTab.dataImob.inicio = item.filtros.dataImobilizacaoInicial
          ? this.parseDate(item.filtros.dataImobilizacaoInicial)
          : "";
        this.firstTab.dataImob.fim = item.filtros.dataImobilizacaoFinal
          ? this.parseDate(item.filtros.dataImobilizacaoFinal)
          : "";
        this.firstTab.dataImob.inicioFormatted = item.filtros.dataImobilizacaoInicial;
        this.firstTab.dataImob.fimFormatted = item.filtros.dataImobilizacaoFinal;

        this.firstTab.tipoBase = item.filtros.tipoBase;

        // Flags
        if (this.secondTab.aplicarFlags) {
          this.secondTab.criarListaExcecaoObras = item.parametros.flagsCriarListaExcecaoObras == 1 ? true : false;
          this.secondTab.obrasNaoAplicaveis = item.parametros.flagsObrasNaoAplicaveis;

          this.secondTab.criarListaExcecaoMateriais =
            item.parametros.flagsCriarListaExcecaoMaterias == 1 ? true : false;
          this.secondTab.materiaisNaoAplicaveis = item.parametros.flagsMateriaisNaoAplicaveis;

          // Flag Obra com UAR <= 10%
          const flagUarZero = item.parametros.FLG_ODI_UAR_ZERO;

          this.secondTab.flags.flag_uar_zero.aplicacao = flagUarZero.aplicar;
          if (flagUarZero.aplicar != "NAO_APLICAR") {
            this.secondTab.flags.flag_uar_zero.percentualFalha = flagUarZero.perc_falha;
          }

          // Flag Data
          const flagData = item.parametros.FLG_ERR_DT_LMTO;

          this.secondTab.flags.flag_data.aplicacao = flagData.aplicar;
          if (flagData.aplicar != "NAO_APLICAR") {
            this.secondTab.flags.flag_data.percentualFalha = flagData.perc_falha;
            this.secondTab.flags.flag_data.janelaDataImob = flagData.incluirJanelaDataImobilizacao == 1 ? true : false;
            this.secondTab.flags.flag_data.desconsiderarItensZeradosOuNegativos =
              flagData.desconsiderarItensZeradosOuNegativos == 1 ? true : false;
            this.secondTab.flags.flag_data.expurgarItensRacionalizacaoCOM =
              flagData.expurgarItensRacionalizacaoCOM == 1 ? true : false;

            this.secondTab.flags.flag_data.periodosDataLancamento.diasAntes = flagData.numDiasAntes;
            this.secondTab.flags.flag_data.periodosDataLancamento.diasDepois = flagData.numDiasDepois;
            this.secondTab.flags.flag_data.periodosDataLancamento.diasAntesRedesAereas =
              flagData.periodosDataLancamentoPorTipologia.diasAntesRedesAereas;
            this.secondTab.flags.flag_data.periodosDataLancamento.diasDepoisRedesAereas =
              flagData.periodosDataLancamentoPorTipologia.diasDepoisRedesAereas;
            this.secondTab.flags.flag_data.periodosDataLancamento.diasAntesRedesSubterraneas =
              flagData.periodosDataLancamentoPorTipologia.diasAntesRedesSubterraneas;
            this.secondTab.flags.flag_data.periodosDataLancamento.diasDepoisRedesSubterraneas =
              flagData.periodosDataLancamentoPorTipologia.diasDepoisRedesSubterraneas;
            this.secondTab.flags.flag_data.periodosDataLancamento.diasAntesMedidores =
              flagData.periodosDataLancamentoPorTipologia.diasAntesMedidores;
            this.secondTab.flags.flag_data.periodosDataLancamento.diasDepoisMedidores =
              flagData.periodosDataLancamentoPorTipologia.diasDepoisMedidores;
            this.secondTab.flags.flag_data.periodosDataLancamento.diasAntesSubestacoes =
              flagData.periodosDataLancamentoPorTipologia.diasAntesSubestacoes;
            this.secondTab.flags.flag_data.periodosDataLancamento.diasDepoisSubestacoes =
              flagData.periodosDataLancamentoPorTipologia.diasDepoisSubestacoes;
            this.secondTab.flags.flag_data.periodosDataLancamento.diasAntesLinhas =
              flagData.periodosDataLancamentoPorTipologia.diasAntesLinhas;
            this.secondTab.flags.flag_data.periodosDataLancamento.diasDepoisLinhas =
              flagData.periodosDataLancamentoPorTipologia.diasDepoisLinhas;

            this.secondTab.flags.flag_data.periodosDataLancamento.aplicarPeriodoRedesAereas =
              flagData.periodosDataLancamentoPorTipologia.aplicarPeriodoRedesAereas == 1 ? true : false;
            this.secondTab.flags.flag_data.periodosDataLancamento.aplicarPeriodoRedesSubterraneas =
              flagData.periodosDataLancamentoPorTipologia.aplicarPeriodoRedesSubterraneas == 1 ? true : false;
            this.secondTab.flags.flag_data.periodosDataLancamento.aplicarPeriodoMedidores =
              flagData.periodosDataLancamentoPorTipologia.aplicarPeriodoMedidores == 1 ? true : false;
            this.secondTab.flags.flag_data.periodosDataLancamento.aplicarPeriodoSubestacoes =
              flagData.periodosDataLancamentoPorTipologia.aplicarPeriodoSubestacoes == 1 ? true : false;
            this.secondTab.flags.flag_data.periodosDataLancamento.aplicarPeriodoLinhas =
              flagData.periodosDataLancamentoPorTipologia.aplicarPeriodoLinhas == 1 ? true : false;
          }
        }

        // Caderno de Serviços
        if (this.thirdTab.aplicarCadernoServicos) {
          this.thirdTab.cadernoServico.origem =
            item.origem_caderno_servicos === "CSV"
              ? "novo"
              : item.origem_caderno_servicos === "CADERNO"
              ? "existente"
              : "sistema";

          if (item.origem_caderno_servicos == "CSV") {
            this.thirdTab.cadernoServico.arquivo.id = item.arquivo.id;
            this.thirdTab.cadernoServico.arquivo.fileObj = new File([""], item.arquivo.arquivo, { type: "text/csv" });
            this.thirdTab.cadernoServico.arquivo.fakeFile = true;
            this.thirdTab.cadernoServico.arquivo.headerValido = true;
            this.thirdTab.cadernoServico.arquivo.delimitador = item.delimitador;
            this.thirdTab.cadernoServico.arquivo.involucro = item.involucro;
            this.thirdTab.cadernoServico.arquivo.escape = item.escape;
          } else if (item.origem_caderno_servicos == "CADERNO") {
            this.thirdTab.cadernoServico.id = item.caderno_servicos_id;
          }

          this.thirdTab.camposPercentuaisPadroes.joa.value = item.parametros.percentuais_padroes["JOA"];
          this.thirdTab.camposPercentuaisPadroes.materialCOM.value =
            item.parametros.percentuais_padroes["Material - COM"];
          this.thirdTab.camposPercentuaisPadroes.materialUAR.value =
            item.parametros.percentuais_padroes["Material - UAR"];
          this.thirdTab.camposPercentuaisPadroes.mop.value = item.parametros.percentuais_padroes["MOP"];
          this.thirdTab.camposPercentuaisPadroes.outros.value = item.parametros.percentuais_padroes["Outros"];
          this.thirdTab.camposPercentuaisPadroes.servTec.value = item.parametros.percentuais_padroes["Serv. Terc."];
        }

        // Racionalização do COM
        if (this.fourthTab.calculoRacionalizacaoDoCom) {
          this.fourthTab.cmu.id = item.cmu_id;
          this.fourthTab.cmu.valores = item.parametros.siglas_aneel_valores;

          this.fourthTab.normasTecnicas.id = item.normas_tecnicas_id;
          this.fourthTab.normasTecnicas.valores = item.parametros.normas_quantidades_com;
          this.fourthTab.parametrosEspecificosRacCom = item.parametros.parametrosEspecificosRacCom;
        }
      },
    },

    watch: {
      calculo() {
        this.fillFields();
      },
    },
  };
</script>
